export var COMPONENT_ID_ENUM;
(function (COMPONENT_ID_ENUM) {
    COMPONENT_ID_ENUM["COURSE_DETAILS_ACADEMIC_REQUIREMENT"] = "COURSE_DETAILS_ACADEMIC_REQUIREMENT";
    COMPONENT_ID_ENUM["COURSE_DETAILS_ADDITIONAL_REQUIREMENT"] = "COURSE_DETAILS_ADDITIONAL_REQUIREMENT";
    COMPONENT_ID_ENUM["COURSE_DETAILS_ENGLISH_EXAM_REQUIREMENT"] = "COURSE_DETAILS_ENGLISH_EXAM_REQUIREMENT";
    COMPONENT_ID_ENUM["COURSE_DETAILS_SCHOLARSHIP"] = "COURSE_DETAILS_SCHOLARSHIP";
    COMPONENT_ID_ENUM["COURSE_DETAILS_OVERVIEW"] = "COURSE_DETAILS_OVERVIEW";
    COMPONENT_ID_ENUM["COURSE_DETAILS_SIMILAR_COURSES"] = "COURSE_DETAILS_SIMILAR_COURSES";
    COMPONENT_ID_ENUM["COURSE_DETAILS_SIMILAR_STUDENTS"] = "COURSE_DETAILS_SIMILAR_STUDENTS";
    COMPONENT_ID_ENUM["COURSE_DETAILS_NAVBAR"] = "COURSE_DETAILS_NAVBAR";
    COMPONENT_ID_ENUM["COURSE_LIKED_SECTION"] = "COURSE_LIKED_SECTION";
    COMPONENT_ID_ENUM["COURSE_DETAILS_APPLICATION_FILING_REQUIREMENTS"] = "COURSE_DETAILS_APPLICATION_FILING_REQUIREMENTS";
})(COMPONENT_ID_ENUM || (COMPONENT_ID_ENUM = {}));
//# sourceMappingURL=types.js.map